import { Palette, Sparkles, Store, Timer, Truck, type LucideIcon } from 'lucide-react';
import type { SetupStepId } from './setup-progress.ts';

export const SETUP_STEP_ICONS: Readonly<Record<SetupStepId, LucideIcon>> = {
  welcome: Sparkles,
  store: Store,
  brand: Palette,
  delivery: Truck,
  orders: Timer,
};
